import { a as o_global } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const device = o_global.device ?? {};
const os = device.os;
const browser = device.browser;
const type = device.type;
const hybrid = device.hybrid;
const orientation = device.orientation;
const deviceAsync = otto.device ?? {};
const pointerType = deviceAsync.pointerType;
const getPointerType = deviceAsync.getPointerType;
const getScreenSpecs = deviceAsync.getScreenSpecs;
export {
  browser,
  device,
  deviceAsync,
  getPointerType,
  getScreenSpecs,
  hybrid,
  orientation,
  os,
  pointerType,
  type
};
/*                                      */
